import { useEffect, useState } from "react";
import { Zap, CalendarClock } from "lucide-react";

export function DeliveryBadge({ mode }) {
  if (mode === "express")
    return (
      <span className="badge-express" data-testid="badge-express">
        <Zap className="h-3 w-3" /> Express · 90 min SLA
      </span>
    );
  return (
    <span className="badge-scheduled" data-testid="badge-scheduled">
      <CalendarClock className="h-3 w-3" /> Scheduled Freight
    </span>
  );
}

const STATUS_STYLES = {
  placed: "bg-blue-500/10 border-blue-500/40 text-blue-700",
  accepted: "bg-indigo-500/10 border-indigo-500/40 text-indigo-700",
  dispatched: "bg-amber-500/10 border-amber-500/40 text-amber-700",
  delivered: "bg-emerald-500/10 border-emerald-500/40 text-emerald-700",
  cancelled: "bg-red-500/10 border-red-500/40 text-red-700",
};

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-300"}`}>
      {status}
    </span>
  );
}

export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

export function Countdown({ deadline, label = "left" }) {
  const now = useNow();
  if (!deadline) return null;
  const ms = new Date(deadline).getTime() - now;
  const breached = ms <= 0;
  const abs = Math.abs(ms);
  const mm = Math.floor(abs / 60000);
  const ss = Math.floor((abs % 60000) / 1000);
  return (
    <span data-testid="sla-countdown" className={`font-mono2 text-xs font-semibold ${breached ? "text-red-600" : "text-slate-700"}`}>
      {breached ? "SLA BREACH " : ""}{mm}:{String(ss).padStart(2, "0")} {label}
    </span>
  );
}

export function fmtDate(d) {
  if (!d) return "—";
  return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function inr(n) {
  return `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}
